import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_babel-plugin_kmcjxw64v75et5qz5d4fasjzoa/node_modules/next/dist/client/script.js");
